import rootReducer from '@/store/rootReducer';
import { createSlice, PayloadAction, WithSlice } from '@reduxjs/toolkit';
import { ReactElement } from 'react';

type DialogOptions = {
	maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
	fullWidth?: boolean;
	paperClassName?: string;
};

type InitialStateProps = {
	open: boolean;
	children: ReactElement | string;
	options?: DialogOptions;
};

/**
 * The initial state of the dialog slice.
 */
const initialState: InitialStateProps = {
	open: false,
	children: '',
	options: {}
};

/**
 * The Fuse Dialog slice
 */
export const fuseDialogSlice = createSlice({
	name: 'fuseDialog',
	initialState,
	reducers: {
		openDialog: (state, action: PayloadAction<{
			children: InitialStateProps['children'];
			options?: DialogOptions;
		}>) => {
			state.open = true;
			state.children = action.payload.children;
			state.options = action.payload.options || {};
		},
		closeDialog: () => initialState
	},
	selectors: {
		selectFuseDialogState: (fuseDialog) => fuseDialog.open,
		selectFuseDialogProps: (fuseDialog) => fuseDialog
	}
});

/**
 * Lazy load
 * */
rootReducer.inject(fuseDialogSlice);
const injectedSlice = fuseDialogSlice.injectInto(rootReducer);
declare module '@/store/rootReducer' {
	export interface LazyLoadedSlices extends WithSlice<typeof fuseDialogSlice> { }
}

export const { closeDialog, openDialog } = fuseDialogSlice.actions;

export const { selectFuseDialogState, selectFuseDialogProps } = injectedSlice.selectors;

export type dialogSliceType = typeof fuseDialogSlice;

export default fuseDialogSlice.reducer;
